export const STATUS_COMMAND_CONFIG = {
    // The command to send when clicking "ASK STATUS"
    statusCommand: 'iposition',

    // Optional: commands for other buttons if needed later
    // diagnosticsCommand: 'GET_DIAGNOSTICS'
};
